/** Wrapper for all the vendor services */

import type { FC, PropsWithChildren } from 'react'
import { useCrisp } from './crisp/crisp.hook.js'
import { Posthog } from './posthog/posthog.js'
import { useSentry, sentryStyles } from './sentry/sentry.hook.js'
import { GlobalStyles, useColorScheme } from '@mui/material'

const crispStyles = {
  '--crisp-customization-container-index': '1000000',
  '--crisp-customization-default-button-horizontal': '0px',
  '--crisp-customization-default-button-vertical': '32px',
  '--crisp-customization-mobile-button-horizontal': '0px',
  '--crisp-customization-mobile-button-vertical': '32px',
}

const globalStyles = {
  ':root': { ...sentryStyles, ...crispStyles },
  'html body .crisp-client': {
    ...crispStyles,
  },
}

export const VendorServices: FC<PropsWithChildren> = ({ children }) => {
  const { colorScheme = 'light' } = useColorScheme()

  useSentry({ mode: colorScheme })

  /** Crisp communication with users */
  useCrisp()

  return (
    <Posthog>
      <GlobalStyles styles={globalStyles} />
      {children}
    </Posthog>
  )
}
